<template>
  <div class="d-flex flex-column ga-6 border pa-6 rounded-sm">
    <BlockTitle title="Отзывы врачей" />
    <div
      v-for="doctorReview in doctorReviews"
      :key="doctorReview.id"
      class="d-flex"
    >
      <img
        :src="isMobile ? doctorReview.avatar_small.url : doctorReview.avatar_large.url"
        alt="/"
        class="mr-4 rounded-circle d-block"
        width="80px"
        height="80px"
      >
      <div>
        <AdminButton
          text="править"
          :link="reverseFull({ name: 'admin:info_review_change', args: [doctorReview.id] })"
        />
        <div class="text-subtitle-1">
          {{ doctorReview.surname }} {{ doctorReview.firstname }} {{ doctorReview.secondname }}
        </div>
        <div class="text-body-2 mb-4 text-secondary--text">
          {{ doctorReview.position }}
        </div>
        <div class="text-body-2">
          {{ doctorReview.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useContextStore, useURLStore } from 'src/store'
import BlockTitle from 'src/components/pages/info/pressa/components/BlockTitle.vue'
import AdminButton from 'src/components/common/AdminButton/AdminButton.vue'
import { DoctorReview } from 'src/components/pages/info/pressa/types'

const { reverseFull, urls, patch } = useURLStore()
const { context } = useContextStore()

if (process.env.IS_SERVER && context.request.user.is_staff && context.flavour === 'full') {
  patch({ 'admin:info_review_change': urls['admin:info_review_change'] })
}

defineProps<{
  doctorReviews: DoctorReview[]
}>()

const isMobile = context.flavour === 'mobile'
</script>
